import { Stack } from '@mui/material';
import { generateClient } from 'aws-amplify/api';
import { useEffect, useState } from 'react';
import { Schema } from '../../../../../amplify/data/resource';
import EmptyStateText from '../../../../components/custom/EmptyStateText';
import List from './List';

const apiClient = generateClient<Schema>();

const paymentSelectionSet = [
  'id',
  'link',
  'validUntil',
  'createdAt',
  'sentBy',
  'clientBank',
  'clientBranch',
  'clientAccount',
  'clientFullName',
  'clientId',
  'fee',
  'paymentAmount',
  'polisaNumber',
  'description',
  'product',
  'user.fullName',
  'user.agencyName',
];

const Payments = () => {
  const [payments, setPayments] = useState<File[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchPayments = async () => {
      setLoading(true);
      try {
        const subscription = apiClient.models.AgentPaymentLink.observeQuery({
          selectionSet: [
            'id',
            'link',
            'validUntil',
            'createdAt',
            'sentBy',
            'clientBank',
            'clientBranch',
            'clientAccount',
            'clientFullName',
            'clientId',
            'fee',
            'paymentAmount',
            'polisaNumber',
            'description',
            'product',
            'user.fullName',
          ],
        }).subscribe({
          next: ({ items }: { items: any[] }) => {
            console.log('fetchPayments:next:', items);
            setPayments(items);
            setLoading(false);
          },
          error: (error: any) => {
            console.error('Error fetching clients:', error);
            setLoading(false);
          },
        });

        return () => subscription.unsubscribe();
      } catch (error) {
        console.error('Error during fetchUsers:', error);
        setLoading(false);
      }
    };

    fetchPayments();
  }, []);

  return (
    <Stack>
      {payments.length === 0 ? (
        <EmptyStateText text="אין הוראות תשלום" />
      ) : (
        <Stack>
          <List payments={payments} />
        </Stack>
      )}
    </Stack>
  );
};

export default Payments;
